{
  "#WERKSTAETTENAUFTRAG": {
    "APP": "Werkstätten Aufträge"
  },
  "#WORKSHOP": {
    "TITLE": "Aufträge",
    "ACTIONS": {
      "OVERVIEW": "Übersicht"
    },
    "COMPONENTS": {
      "CREATE_TASK": {
        "TITLE": "Auftrag erstellen"
      },
      "OVERVIEW": {
        "TITLE": "Aufträge",
        "NO_DATA": "Es konnten keine Aufträge gefunden werden"
      },
      "DETAIL": {
        "TITLE": "Auftrag"
      }
    },
    "VALIDATION": {
      "ERROR": "Ungültig",
      "TIME": "Die Von-Zeit darf nicht größer als die Bis-Zeit sein. "
    },
    "MESSAGES": {
      "ERRORS": {
        "TITLE": "Fehler",
        "SCAN_FAILURE": "Beim Scannen des Barcodes ist ein Fehler aufgetreten",
        "SCAN_VALIDATE_FAILURE": "Der gescannte Barcode konnte nicht validiert werden.",
        "LOAD_TASKS_FAILURE": "Beim Laden der Aufträge ist ein Fehler aufgetreten!",
        "CREATE_FAILURE": "Der Auftrag konnte nicht erstellt werden!"
      },
      "WARNING": {
        "TITLE": "Warnung",
        "MULTI_ACTIVE_TIME_REPORTS": "Es ist mehr als ein Arbeitsbericht offen! Bitte setzen Sie die Endzeit über die Zeiterfassung"
      },
      "SUCCESS": {
        "TITLE": "Erfolgreich",
        "CREATE_SUCCESS": "Der Auftrag wurde erstellt",
        "CREATE_LINK": "Zum Auftrag",
        "ADD_ITEMS": "Die Artikel wurden dem Auftrag hinzugefügt",
        "ADD_TIME_REPORT": "Die Arbeitszeiten wurden erfasst",
        "SIGN": "Der Auftrag wurde unterschrieben"
      }
    },
    "TASK_OUTLINE": {
      "TITLE": "Offene Aufträge",
      "CREATE": {
        "MENU_TITLE": "Neuer Auftrag"
      },
      "SEARCH": {
        "PLACEHOLDER": "Auftragsbezeichnung oder Nummer"
      }
    },
    "TASK_DETAILS": {
      "ACTIONS": {
        "TITLE": "Aktionen"
      },
      "DELETE": {
        "ITEM": {
          "QUESTION": "Sind Sie sicher, dass Sie das Material unwiderruflich vom Auftrag entfernen wollen?",
          "ERROR": "Das Material konnte nicht entfernt werden!",
          "SUCCESS": "Material wurde erfolgreich vom Auftrag entfernt!"
        },
        "REPORT": {
          "QUESTION": "Sind Sie sicher, dass Sie die Tätigkeit unwiderruflich löschen wollen?",
          "ERROR": "Die Tätigkeit konnte nicht entfernt werden!",
          "SUCCESS": "Die Tätigkeit wurde erfolgreich gelöscht!"
        }
      },
      "CUSTOMER": {
        "HEADER": "Kunde",
        "CONTACTS": {
          "TITLE": "Kontaktdaten",
          "MAIL1": "E-Mail 1:",
          "MAIL2": "E-Mail 2:",
          "MAIL3": "E-Mail 3:",
          "PHONE_FIRMA": "Telefon Firma:",
          "PHONE_PRIVAT": "Telefon Privat:"
        },
        "ADDRESS": {
          "GOOGLE_MAPS": "Google Maps"
        }
      },
      "SELLING_TYPE": {
        "HEADER": "Verkaufsart"
      },
      "HEADER_TEXT": {
        "HEADER": "Kopftext"
      },
      "SHIPPING_INFO": {
        "HEADER": "Lieferhinweise"
      },
      "ITEMS": {
        "HEADER": "Materialschein"
      },
      "QUICK_ACTIONS": {
        "HEADER": "Schnellaktionen",
        "ADD_ITEMS": "Material hinzufügen",
        "WORK_REPORT": "Tätigkeit erfassen",
        "DESCRIPTION": "Weitere Aktionen finden Sie im Aktionsmenü. Über die drei Punkte in der Menüleiste gelangen Sie zum Aktionsmenü."
      },
      "REPORTS": {
        "HEADER": "Tätigkeitserfassung"
      },
      "PICTURES": {
        "HEADER": "Fotos"
      },
      "SIGN": {
        "HEADER": "Unterschrift",
        "STATUS_ERROR": "Ausstehend",
        "STATUS_OK": "Unterschrieben",
        "HINT": "Tippen Sie um eine Unterschrift hinzuzufügen"
      },
      "CLOSE": "Auftrag abschließen",
      "COMMANDS": {
        "ADD_PHOTOS": "Foto hinzufügen",
        "ADD_TASK_ITEM": "Material hinzufügen",
        "CLOSE_TASK": "Auftrag abschließen",
        "EDIT_HEADER": "Kopftext bearbeiten",
        "END_ACTIVITY": "Tätigkeit beenden",
        "MANUAL_TIME_REPORT": "Manuelle Erfassung",
        "SIGNATURE": "Unterschreiben",
        "START_ACTIVITY": "Tätigkeit starten"
      }
    },
    "ADD_TASK_ITEMS": {
      "TITLE": "Material hinzufügen",
      "FORM": {
        "HEADER": "Artikel wählen",
        "ITEM": "Artikel auswählen",
        "QUANTITY": "Menge (leer = 1)",
        "PRICE": "Preis",
        "LAST_EK_PRICE": "Letzter EK-Preis",
        "DISCOUNT": "Rabatt",
        "CHANGE": "Preis/Rabatt ändern",
        "SUBMIT": "Hinzufügen"
      },
      "ITEMS": {
        "HEADER": "Hinzugefügte Artikel",
        "PLACEHOLDER": "Sie haben noch keine Artikel hinzugefügt"
      },
      "ABORT": "Abbrechen",
      "SAVE": "Speichern",
      "SAVE_ERROR": "Beim Hinzufügen der Artikel ist ein Fehler aufgetreten!"
    },
    "WORK_REPORT": {
      "MANUAL": {
        "TITLE": "Arbeitsbericht",
        "HEADER": "Tätigkeit erfassen",
        "FORM": {
          "TITLE": "Neue Tätigkeit",
          "ACTIVITY": "Aktivität/Tätigkeit",
          "DATE": "Datum",
          "MULTILINE": "Beschreibung",
          "FROM": "von",
          "TO": "bis",
          "ADD": "Tätigkeit erfassen"
        },
        "ITEMS": {
          "HEADER": "Erfasste Tätigkeiten",
          "PLACEHOLDER": "Es wurde noch keine Tätigkeit erfasst"
        },
        "ABORT": "Abbrechen",
        "SAVE": "Speichern",
        "SAVE_ERROR": "Beim Speichern der Tätigkeiten ist ein Fehler aufgetreten!"
      },
      "NO_ACTIVITY": "Keine Aktivität"
    },
    "DIALOGS": {
      "ABORT": "Abbrechen",
      "SUBMIT_TAKE": "Übernehmen",
      "SUBMIT_CONTINUE": "Weiter",
      "SUBMIT_SAVE": "Speichern",
      "ERROR_SUBJECT": "Fehler",
      "TRY_AGAIN": "Erneut Versuchen",
      "UPLOAD_IMAGE": {
        "TITLE": "Tippen Sie um ein Foto hinzuzufügen"
      },
      "CHANGE_PRICE": {
        "TITLE": "Preis/Rabatt anpassen",
        "PRICE_LABEL": "Preis",
        "DISCOUNT_LABEL": "Rabatt (in Prozent)"
      },
      "CLOSE_TASK": {
        "TITLE": "Auftrag abschließen",
        "INSTRUCTIONS": "Wählen Sie die Freigabeart des Auftrags aus. Klicken Sie anschließend auf weiter um den Auftrag abzuschließen.",
        "APPROVAL": "Abrechnungsfreigabe",
        "DELIVERY_NOTE": "Lieferschein",
        "INVOICE": "Kreditrechnung",
        "ERROR": "Der Auftrag konnte nicht abgeschlossen werden"
      },
      "CREATE_TASK": {
        "TITLE": "Neuer Auftrag",
        "CREATE": "Auftrag anlegen",
        "CUSTOMER": "Kunde",
        "TASK_TITLE": "Auftragstitel",
        "HEADER_TEXT": "Kopftext",
        "SELLING_METHOD": "Verkaufsart",
        "VEHICLE": "Fahrzeug",
        "KILOMETERS": "Kilometerstand",
        "OPERATING_HOURS": "Betriebsstunden",
        "ERROR": "Der Auftrag konnte nicht erstellt werden"
      },
      "EDIT_HEADER": {
        "TITLE": "Kopftext bearbeiten",
        "ERROR": "Die Änderungen am Kopftext konnten nicht gespeichert werden"
      },
      "END_ACTIVITY": {
        "TITLE": "Erfassung stoppen?",
        "DESCRIPTION": "Sind Sie sicher, dass Sie die Zeiterfassung stoppen wollen?",
        "STOP": "Erfassung stoppen",
        "ERROR": "Die Tätigkeitserfassung konnte nicht gestoppt werden"
      },
      "SIGNATURE": {
        "TITLE": "Bitte unterschreiben Sie im Feld darunter:",
        "ERROR": "Die Unterschrift konnte nicht gespeichert werden"
      },
      "START_ACTIVITY": {
        "TITLE": "Tätigkeitserfassung starten",
        "START": "Erfassung starten",
        "DESCRIPTION_LABEL": "Beschreibung (Optional)",
        "ACTIVITY_LABEL": "Tätigkeit",
        "ERROR": "Die Tätigkeit konnte nicht gestartet werden"
      }
    },
    "SHARED": {
      "LOADING_INFO": "Bitte warten..."
    }
  }
}
